import { Route, Routes } from "react-router-dom";
import { Routes as FleetCascoRoutes } from "./routes";
import { FleetCascoRouterCmp } from "./types";
import { CascoExpirySearchPage } from "../pages/CascoExpirySearchPage";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const FleetCascoRouter: FleetCascoRouterCmp = () => {
  return (
    <>
      <Routes>
        <Route
          path={CascoExpirySearchPage.route}
          element={<CascoExpirySearchPage />}
        />
      </Routes>
    </>
  );
};

FleetCascoRouter.route = FleetCascoRoutes.FleetCascoRouter;

export default FleetCascoRouter;
